import React, { Component } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
const responsive = {
    desktop: {
        breakpoint: { max: 3000, min: 1024 },
        items: 8,
        slidesToSlide: 1 // optional, default to 1.
    },
    tablet: {
        breakpoint: { max: 1024, min: 550 },
        items: 6,
        slidesToSlide: 1 // optional, default to 1.
    },
    mobile: {
        breakpoint: { max: 550, min: 0 },
        items: 2,
        slidesToSlide: 1 // optional, default to 1.
    }
};
const mystyle = {
    paddingTop: "20px",
    paddingBottom: "20px",
    margin:"5px"
  };
class Aluminicompany extends Component {
    render() {
        return (
            <div>
                <section class="course-tools-covered padding-default" id="course-tools-covered">
                    <h3> Our Alumni work at </h3>
                    <Carousel               
                    responsive={responsive}
                    arrows={false}
                    draggable={true}
                      ssr
                      partialVisible
                      infinite={true}
                      autoPlaySpeed={1000}
                      autoPlay={this.props.deviceType !== "mobile" ? true : false}
                      beforeChange={() => this.setState({ isMoving: true })}
                      afterChange={() => this.setState({ isMoving: false })}
                      containerClass="first-carousel-container container"
                      deviceType={this.props.deviceType}>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center id="Certification-s"> <img class="" alt="Abbott" src="/assets/images/company Folder/Abbott-29.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/ama-14.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/atos-syntel-squarelogo-17.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center><img class="" alt="Abbott" src="/assets/images/company Folder/Bayer Pharmaceuticals - Berlin-8.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Biscon-26.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/canpack-5.jfif" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/client-credit-suisse-1.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Cognizant.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/crisil-22.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/emerson-logo-2.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/eminence-6.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/garnier-logo-18.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/HCL-32.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Heston-31.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Hitachi-15.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/IFF-28.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/infosys-limited-4.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/johnson-controls-3.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/medecins-sans-frontieres-logo-vecto-13.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/MGH-16.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/OTC_TCS-11.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Parker-21.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/RBI-12.jpeg" /></center>
                            </div>
                        </div>
                        <div class="item"> 
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/RSB Transmission (I) Ltd-19.gif" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/S_P Global-27.jfif" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Sandvik -Seco-9.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Springer-25.jfif" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/syngene international Ltd-7.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Tata-Communications-10.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/Veritas Technologie-33.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/wells_fargo-30.jpg" /></center>
                            </div>
                        </div>
                        <div class="item">
                            <div class="card" style={mystyle}>
                                <center> <img class="" alt="Abbott" src="/assets/images/company Folder/zensar-technologies-23.jpg" /></center>
                                <span id="apply-now"></span>
                            </div>
                        </div>
                    </Carousel>
                </section>
            </div>
        );
    }
}

export default Aluminicompany;